//import('jquery.fancybox.min.js');

namespace gotoAndPlay {

    function onInit(): void {

        $('a[href*=".jpg"], a[href*=".jpeg"], a[href*=".gif"], a[href*=".png"]').attr('data-fancybox','group');
        $('a[href*=".jpg"], a[href*=".jpeg"], a[href*=".gif"], a[href*=".png"]').fancybox({
            slideshow: false,
            thumbs: false
        });

    }

    $(document).ready(onInit);
}
